import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import SearchSelect from '../../components/SearchSelect'
import { useGetSelectDriversQuery } from '../../redux/services/DriverService'
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm'
import LoadingButton from '../../components/LoadingButton'
import MultiSelect from '../../components/MultiSelect'

const CompletedJobFilter = ({ setQuery }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const empStatus = [{ title: 'Active', id: 0 }, { title: 'Terminated', id: 1 }, { title: 'Leave', id: 2 }]

    const onSubmit = async (data) => {
        data['amount_status'] = data?.amount_status?.length > 0 ? data?.amount_status?.map((item) => item?.value)?.join(',') : '';

        // send data as a query params
        if (data?.amount_status) {
            setQuery({ id: data?.amount_status?.toString() })
        }
    }
    return (
        <>
            <div className="p-4" id="collapse-inputs">
                <Form className='row align-items-end' onSubmit={handleSubmit(onSubmit)} id='filter-management'>
                    <div className="col-lg-4">
                        <Form.Group className="mb-0">
                            <Form.Label> Amount Status:</Form.Label>
                            <Controller
                                name="amount_status"
                                control={control}
                                defaultValue=""
                                rules={{
                                    required: false
                                }}
                                render={({ field }) => (
                                    <>
                                        {/* <SearchSelect
                                            options={empStatus?.map((item) => ({ value: item?.id, label: item?.title }))}
                                            field={field}
                                            placeholder={"Select Employment Status"}
                                        /> */}
                                        <MultiSelect
                                            options={
                                                [
                                                    { label: 'PAID', value: 'PAID' },
                                                    { label: 'UNPAID', value: 'UNPAID' },
                                                ]
                                            }
                                            field={field}
                                            placeholder={"Select Employment Status"}
                                        />
                                        {errors.amount_status && <div className="invalid-feedback d-block">This field is required</div>}
                                    </>

                                )}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-lg-2 col-md-4">
                        <LoadingButton
                            // isLoading={editLoading ? editLoading : addLoading}
                            name="Reset Filter"

                            className='w-100'
                            onClick={() => {
                                reset({
                                    amount_status: '',
                                })
                                console.log('reset')
                                setQuery(null)
                            }}
                            type="button"
                        />
                    </div>
                    <div className="col-lg-2 col-md-4">
                        <LoadingButtonWithForm
                            // isLoading={editLoading ? editLoading : addLoading}
                            name="Filter"
                            form="filter-management"
                            className='w-100'
                        />
                    </div>


                </Form>
            </div>

        </>
    )
}

export default CompletedJobFilter